const TEMPLATE_TEXT = {
  title: '日管控检查表设置',
  create: '新建模板',
  initialize: '使用系统推荐模板',
  itemLibrary: '检查项目库',
  selectItems: '选择检查项目',
}

function normalizeStatus(status) {
  const value = Number(status)
  return Number.isNaN(value) ? 0 : value
}

function getTemplateStatusMeta(status) {
  const map = {
    0: { text: '草稿', color: 'blue' },
    1: { text: '启用', color: 'green' },
    2: { text: '停用', color: 'red' },
  }
  return map[normalizeStatus(status)] || map[0]
}

function getTemplateItemCount(template) {
  if (!template) return 0
  if (Array.isArray(template.related_items) && template.related_items.length > 0) {
    return template.related_items.length
  }
  const count = Number(template.item_count || template.related_item_count || 0)
  return Number.isNaN(count) ? 0 : count
}

function getDefaultActionState(template) {
  if (template && template.is_default) {
    return { disabled: true, text: '当前默认', reason: '该模板已是默认模板' }
  }
  const status = normalizeStatus(template && template.status)
  if (status === 0) {
    return { disabled: true, text: '草稿不可设默认', reason: '草稿模板不能设为默认，请先启用模板' }
  }
  if (status === 2) {
    return { disabled: true, text: '停用不可设默认', reason: '停用模板不能设为默认，请先启用模板' }
  }
  return { disabled: false, text: '设为默认', reason: '' }
}

function getTemplatePrimaryActions(template) {
  const actions = [
    { key: 'preview', text: '预览' },
    { key: 'edit', text: '编辑' },
    { key: 'copy', text: '复制' },
  ]
  const defaultState = getDefaultActionState(template)
  if (!defaultState.disabled) {
    actions.push({ key: 'setDefault', text: defaultState.text })
  }
  if (normalizeStatus(template && template.status) === 2) {
    actions.push({ key: 'enable', text: '启用' })
  } else {
    actions.push({ key: 'stop', text: '停用' })
  }
  actions.push({ key: 'delete', text: '删除' })
  return actions
}

function getTemplatePreviewGroups(template) {
  if (!template || !Array.isArray(template.related_items)) return []
  const groups = []
  template.related_items.forEach((item) => {
    const groupName = item.parent_item_name || item.parent_name || item.category_name || item.item_group || '检查项目'
    let group = groups.find(entry => entry.name === groupName)
    if (!group) {
      group = { name: groupName, items: [] }
      groups.push(group)
    }
    group.items.push(item)
  })
  return groups
}

function mergeSelectedItemDetails(existingDetails, pageItems, selectedIds) {
  const byId = new Map()
  ;(existingDetails || []).forEach((item) => {
    if (item && item.id !== undefined && item.id !== null) byId.set(Number(item.id), item)
  })
  ;(pageItems || []).forEach((item) => {
    if (item && item.id !== undefined && item.id !== null) byId.set(Number(item.id), item)
  })
  return (selectedIds || []).map((id) => {
    const numericId = Number(id)
    const detail = byId.get(numericId)
    if (detail) return detail
    return { id: numericId, item_no: '', item_name: `项目 ${id}` }
  })
}

module.exports = {
  TEMPLATE_TEXT,
  getTemplateStatusMeta,
  getTemplateItemCount,
  getDefaultActionState,
  getTemplatePrimaryActions,
  getTemplatePreviewGroups,
  mergeSelectedItemDetails,
}
